import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import FormInputWithCounter from '../../../../../components/FormInputWithCounter';

interface Props {
  open: boolean;
  onClose: () => void;
  totalCount: number;
  handleRemove: (selectedCount: number) => void;
}
function RemoveItemModal({ open, onClose, totalCount, handleRemove }: Props) {
  const { t } = useTranslation('pos');

  const [count, setCount] = useState(1);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    setCount(1);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={t('orderModal.giftModal.removeOrderTitle')}
      positiveAction={t('orderModal.giftModal.confirm')}
      onPositiveClick={() => {
        handleRemove(count);
        handleClose();
      }}
      negativeAction={t('orderModal.giftModal.cancel')}
      onNegativeClick={handleClose}
    >
      <FormInputWithCounter
        onIncrease={() => count !== totalCount && setCount(count + 1)}
        onDecrease={() => {
          if (count > 1) {
            setCount(count - 1);
          }
        }}
        value={count}
        onChange={(event: any) =>
          setCount(
            parseInt(
              Number(event.target.value) < 1 ? '1' : event.target.value,
              10,
            ),
          )
        }
        disableUnderline
      />
    </Modal>
  );
}

export default RemoveItemModal;
